// @flow
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import ImageLoader from '../../../common/image-loader/ImageLoaderComponent';
import * as abstractWindow from '../../../../abstraction/window';

import './TemplateTile.scss';

type Props = {
  name: string,
  image: string,
  paperOption: string,
  paperOptionRestricted: boolean,
  quantity: {
    from: number,
    to: number,
  },
  creationLink: string,
};

/**
 * Tiles used in step 2 of the creation flow to represent product templates
 */

class TemplateTileComponent extends React.Component<Props> {
  static displayName = 'TemplateTile';

  static propTypes = {
    name: PropTypes.string.isRequired,
    paperOption: PropTypes.string.isRequired,
    paperOptionRestricted: PropTypes.bool.isRequired,
    quantity: PropTypes.shape({
      from: PropTypes.number.isRequired,
      to: PropTypes.number.isRequired,
    }).isRequired,
    creationLink: PropTypes.string.isRequired,
  };

  static contextTypes = {
    intl: intlShape.isRequired,
  };

  onTemplateSelected = (): void => {
    abstractWindow.location.assign(this.props.creationLink);
  };

  paperOption() {
    const { paperOption, paperOptionRestricted } = this.props;

    if (paperOptionRestricted === true) {
      return paperOption;
    }

    return <FormattedMessage id="app.creation.paperOptionUnrestricted" defaultMessage="Available in any paper stock" />;
  }

  paperQuantity(): Element {
    const { from, to } = this.props.quantity;

    if (from === 0 && to === 0) {
      return <FormattedMessage id="app.creation.quantityUnrestricted" defaultMessage="Available in any quantity" />;
    }
    return (
      <FormattedMessage id="app.creation.quantityRange" defaultMessage="Quantity {from} - {to}" values={{ from, to }} />
    );
  }

  render() {
    const { name } = this.props;
    const hasCroppedName = name.length > 80;
    const nameTooltip = hasCroppedName ? name : '';
    const tooltipClassName = hasCroppedName ? ' template-tile-container__info-name--hinted' : '';

    return (
      <div
        className="template-tile-component template-selection-tiles-component__item"
        onClick={this.onTemplateSelected}
      >
        <div className="template-tile-container">
          <ImageLoader image={this.props.image} altText={this.props.name} />
          <div className="template-tile-container__info u-fontFamily-secondary">
            <div
              className={`template-tile-container__info-name u-fontFamily-primaryMedium ${tooltipClassName}`}
              title={nameTooltip}
            >
              {name}
            </div>
            <div className="template-tile-container__info-paper">{this.paperOption()}</div>
            <div className="template-tile-container__info-quantity">{this.paperQuantity()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default TemplateTileComponent;
